$(document).on("turbolinks:load", function () {
  function drawResult(array) {
    for (let job of array) {
      let progressContainer = $(`#progress-${job.id}`);
      let statusContainer = $(`#status-${job.id}`);
      let updatedAtContainer = $(`#updated-at-${job.id}`);

      var percentage = Math.round(job.current_value / (job.max_value / 100));
      if (isNaN(percentage) || percentage > 100) {
        percentage = 100;
      }
      let bar = `<div style="width: ${percentage}%" class="progress-bar" role="progressbar">${percentage}%</div>`;

      progressContainer.html(bar);
      statusContainer.text(job.status);
      updatedAtContainer.text(job.updated_at);
    }
  }

  let jobsCount = -1;

  function getJobs() {
    $.ajax(`/admin/background_jobs${window.location.search}`, {
      type: "GET",
      dataType: "JSON",
      success: function (data, _textStatus, _jqXHR) {
        if ($(".admin_background_jobs").length) {
          if (jobsCount == -1) {
            jobsCount = data.length;
          }
          if (data.length != jobsCount) {
            jobsCount = data.length;
            location.reload();
          } else {
            drawResult(data);
            setTimeout(getJobs, 5000);
          }
        }
      },
    });
  }

  if ($(".admin_background_jobs.index").length) {
    getJobs();
  }
});
